@if (planKey(); as urlKey) {
  <div
    class="le-banner"
    data-testid="lauf-plan-banner"
    role="group"
    [attr.aria-label]="'testResults.laeufe.banner.ariaLabel' | translate"
  >
    <mat-icon class="le-banner__icon" aria-hidden="true">shield</mat-icon>
    <span class="le-banner__label">{{ 'testResults.laeufe.banner.label' | translate }}</span>
    <code class="le-banner__chip">{{ plan()?.key ?? urlKey }}</code>
    @if (plan(); as p) {
      <span class="le-banner__title">{{ p.titel }}</span>
    }
    <span class="le-banner__spacer"></span>
    @if (plan(); as p) {
      <a class="le-banner__open" data-testid="lauf-plan-open" [routerLink]="planLink(p.id)">
        {{ 'testResults.laeufe.banner.openPlan' | translate }}
        <span aria-hidden="true">↗</span>
      </a>
    }
    <button type="button" class="le-banner__alle" data-testid="lauf-alle" (click)="alleLaeufe.emit()">
      <mat-icon aria-hidden="true">close</mat-icon>
      <span class="le-banner__alle-label">{{ 'testResults.laeufe.banner.alle' | translate }}</span>
    </button>
  </div>
}

<section
  class="le-card"
  [attr.aria-busy]="state().loading || releasesState() === 'loading' || null"
  [attr.aria-label]="'testResults.laeufe.label' | translate"
>
  <div class="le-head">
    <div data-col="lauf">{{ 'testResults.laeufe.head.lauf' | translate }}</div>
    <div data-col="titel">{{ 'testResults.laeufe.head.titel' | translate }}</div>
    <div data-col="plan">{{ 'testResults.laeufe.head.plan' | translate }}</div>
    <div data-col="umgebung">{{ 'testResults.laeufe.head.umgebung' | translate }}</div>
    <div data-col="ergebnis">{{ 'testResults.laeufe.head.ergebnis' | translate }}</div>
    <div data-col="zuletzt">{{ 'testResults.laeufe.head.zuletzt' | translate }}</div>
    <div data-col="chevron"></div>
  </div>

  @if (!releaseId() && releasesState() === 'loading') {
    <p class="le-state" role="status" data-testid="lauf-loading">{{ 'testResults.laeufe.loading' | translate }}</p>
  } @else if (!releaseId() && releasesState() === 'error') {
    <p class="le-state le-state--error" role="alert" data-testid="lauf-releases-error">
      {{ 'testResults.releasesLoadError' | translate }}
    </p>
  } @else if (!releaseId()) {
    <p class="le-state" data-testid="lauf-no-release">{{ 'testResults.laeufe.noRelease' | translate }}</p>
  } @else if (state().error) {
    <p class="le-state le-state--error" role="alert" data-testid="lauf-error">
      {{ 'testResults.laeufe.loadError' | translate }}
    </p>
  } @else if (state().loading) {
    <p class="le-state" role="status" data-testid="lauf-loading">{{ 'testResults.laeufe.loading' | translate }}</p>
  } @else {
    @for (r of rows(); track r.lauf.id) {
      <div class="le-row" data-testid="lauf-row">
        <div data-col="lauf">
          <code class="le-run-chip">{{ r.lauf.key }}</code>
        </div>
        <div data-col="titel">
          <a
            class="le-row__title"
            data-testid="lauf-link"
            [routerLink]="r.link.commands"
            [queryParams]="r.link.queryParams"
          >
            {{ r.lauf.titel }}
          </a>
          <div class="le-row__sub">
            {{ 'testResults.laeufe.release' | translate: { release: r.lauf.release } }} ·
            {{ 'testResults.laeufe.art.' + r.lauf.art | translate }} ·
            {{
              (r.lauf.ausfuehrungenCount === 1
                ? 'testResults.laeufe.ausfuehrungenOne'
                : 'testResults.laeufe.ausfuehrungenMany'
              ) | translate: { count: r.lauf.ausfuehrungenCount }
            }}
          </div>
        </div>
        <div data-col="plan">
          @if (r.lauf.planKey) {
            <a
              class="le-plan-link"
              data-testid="lauf-plan-link"
              [routerLink]="planLink(r.lauf.planId)"
              [attr.title]="'testResults.laeufe.planLinkTitle' | translate"
              [attr.aria-label]="'testResults.laeufe.planLinkAria' | translate: { key: r.lauf.planKey }"
            >
              {{ r.lauf.planKey }}
            </a>
          } @else {
            —
          }
        </div>
        <div data-col="umgebung">{{ r.lauf.umgebung ?? '—' }}</div>
        <div data-col="ergebnis">
          @if (r.kategorie; as kategorie) {
            <app-pipe-kategorie-pill
              [kategorie]="kategorie"
              [compact]="true"
              [aussagekraeftig]="false"
              (click)="openRun(r.link)"
            />
            <span class="le-result__count">{{ 'testResults.laeufe.nichtAusgefuehrt' | translate }}</span>
          } @else {
            <app-res-pill size="sm" [status]="r.result.pill" [label]="r.result.labelKey | translate" />
            <span class="le-result__count">{{ r.lauf.passed }}/{{ r.lauf.gesamt }}</span>
          }
        </div>
        <div data-col="zuletzt">
          @if (r.lauf.zuletzt) {
            {{ r.lauf.zuletzt | date: 'dd.MM.yyyy HH:mm' }}
          } @else {
            —
          }
        </div>
        <div data-col="chevron">
          <mat-icon class="le-row__chevron" aria-hidden="true">chevron_right</mat-icon>
        </div>
      </div>
    } @empty {
      <div class="le-empty" data-testid="lauf-empty">
        {{ (planKey() ? 'testResults.laeufe.emptyPlan' : 'testResults.laeufe.emptyRelease') | translate }}
      </div>
    }
  }
</section>
